import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Image } from 'components/ui';

/**
 * Klarna Pill Button - Release 4 Style
 * Renders as a pill-shaped button with Klarna logo
 */
const KlarnaPill = props => {
    const {
        isKlarnaEnabledForThisOrder, handlePaymentClick, width, height, imageHeight
    } = props;

    // Don't render if Klarna is not enabled
    if (!isKlarnaEnabledForThisOrder) {
        return null;
    }

    return (
        <Button
            variant='primary'
            onClick={handlePaymentClick}
            data-at={Sephora.debug.dataAt('klarna_button')}
            aria-label='Pay with Klarna'
            css={styles}
            height={height || 44}
            minHeight={height || 44}
            width={width || ['100%', '151px', '100%']}
        >
            <Image
                src='/img/ufe/logo-klarna.svg'
                alt=''
                aria-hidden='true'
                height={imageHeight || '15px'}
            />
        </Button>
    );
};

const styles = {
    backgroundColor: '#FFA8CD', // Figma too
    borderRadius: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    gap: '12px',
    flexShrink: 0,
    '&:hover': {
        backgroundColor: '#FFB8D7' // Pulled this from figma
    }
};

export default wrapFunctionalComponent(KlarnaPill, 'KlarnaPill');
